import type { LocationQuery } from 'vue-router'
import useAssessmentStore from '@shared/modules/assessment/stores/useAssessmentStore.js'
import { getOnboardingProgress } from '@eu/app/composables/useOnboardingProgress.js'
import type { RouteName } from '@eu/app/router/appModule/navigation'

export const configureEmbeddedAssessment = (
  finishRoute: RouteName,
  progressFrom: RouteName | undefined,
  query: LocationQuery,
): void => {
  const startProgress = progressFrom ? getOnboardingProgress(progressFrom) : 0
  const endProgress = getOnboardingProgress(finishRoute)
  if (startProgress == null || endProgress == null) {
    throw new Error(
      `[embedded-assessment] route without an onboarding step (progressFrom: ${progressFrom}, finishRoute: ${finishRoute})`,
    )
  }
  useAssessmentStore().setEmbeddedFlowContext({
    finishRoute: { name: finishRoute, query },
    onboardingProgressRange: { startProgress, endProgress },
  })
}
